import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMFAdminAppInitializer } from '../contexts/MFAdminAppInitializer'
import {
  initializeFeaturebaseIdentify,
  initializeFeaturebaseChangelog,
  initializeFeaturebaseSurvey
} from '../redux/storeConfig/slices/slice.integrations'

export default function useFeaturebase() {
  const {
    state: {
      layout: { skin }
    }
  } = useMFAdminAppInitializer()

  /** @type {import('../reducers/adminsReducer').CurrentAdmin} */
  const currentAdmin = useSelector(state => state.admins.current_admin)
  const dispatch = useDispatch()

  const initializeFeaturebase = useCallback(async () => {
    await dispatch(initializeFeaturebaseIdentify(currentAdmin))

    await Promise.all([
      dispatch(initializeFeaturebaseChangelog(currentAdmin, skin)),
      // dispatch(initializeFeaturebaseMessenger(currentAdmin, skin)),
      dispatch(initializeFeaturebaseSurvey(currentAdmin, skin))
    ])
  }, [currentAdmin, dispatch, skin])

  useEffect(() => {
    if (!currentAdmin?.id) return

    if (document.readyState === 'complete') initializeFeaturebase()
    else {
      window.addEventListener('load', initializeFeaturebase)
      return () => window.removeEventListener('load', initializeFeaturebase)
    }
  }, [currentAdmin, initializeFeaturebase])
}
